import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection, Scrolling
    , Export, Summary, TotalItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import {hasRole}    from '../../utils/Utils';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import TesvikSgkLogin from "../sgklogin/TesvikSgkLogin";
import { Popup } from 'devextreme-react/popup';
import { SelectBox } from 'devextreme-react/select-box'; 
import { showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getAllByPlaceholderText } from '@testing-library/react';
import TextBox from "devextreme-react/text-box";
import NumberBox from 'devextreme-react/number-box';
import DateBox from 'devextreme-react/date-box';
import './CariDonemBilgi.scss';

const CariDonemBilgi = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            cariDonemFirmaListeleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemFirmaListeleme"),
            cariDonemBilgiGoruntuleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemBilgiGoruntuleme"),
            cariDonemBilgiKaydetme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemBilgiKaydetme"),
            sgkOnayliDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkOnayliDonemIndir"),
            sgkCariDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkCariDonemIndir"),
            sgkOncekiDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkOncekiDonemIndir"),
            sgkTesvikKaydet: hasRole("cariDonem|cariDonemTesvikRapor|sgkTesvikKaydet"),
            cariDonemExcelXmlImport: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemExcelXmlImport"),
            cariDonemExcelExport: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemExcelExport"),
            cariDonemAktarilanPersonellistesiGoruntuleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemAktarilanPersonellistesiGoruntuleme")
        });

    const listeBasligi = "Teşvik Rapor Fark";
    const [store, setStore] = useState(null);
    const [cariDonemBilgi, setCariDonemBilgi] = useState({
        cariDonemCalisanSayi6111: null,
        cariDonemCalisanSayi7103: null,
        cariDonemKayitliSayi6111: null,
        cariDonemKayitliSayi7103: null,
        cariDonemDataPersonelSayi: null,
        cariDonemId: null,
        cariDonemPersonelGirisSayi: null,
        cariDonemPersonelSayi: null,
        cariDonemTarih: null,
        oncekiDonemBildirgePersonelSayi: null,
        oncekiDonemId: null,
        oncekiDonemPersonelCikisSayi: null,
        oncekiDonemTarihi: null,
        cariDonemTahminiTaseronPersonelSayi:null,
        personelGirisCikisFark :null
    });

    useEffect(() => {

        setStore(getStore());
    }, [])

    function getDate(dateStr) {
        if (dateStr != null) {
            //TODO: düzenlecek
            //"01.08.2020 00:00:00"

            let gun = dateStr.substring(0, 2);
            let ay = parseInt(dateStr.substring(3, 5)) - 1;
            let yil = dateStr.substring(6, 10);
            let saat = dateStr.substring(11, 13);
            let dakika = dateStr.substring(14, 16);
            let sanye = dateStr.substring(17, 19);

            return new Date(yil, ay, gun, saat, dakika, sanye);
        }
        return null;
    }

    const getStore = () => {


        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                const request = new Request("/cariDonemTesvikRapor/getCariDonemRaporTesvikBilgi/" + props.data.domainId, "GET");
                return request.run()
                    .then(response => {
                        if (response.data) {
                            let id = 1;
                            response.data.data.oncekiDonemTesvikBilgiInfoList.map(d => {
                                d.id = id;
                                d.tarih = getDate(d.tarih);
                                id++;
                            });
                            response.data.data.cariDonemTarih = getDate(response.data.data.cariDonemTarih);
                            response.data.data.oncekiDonemTarihi = getDate(response.data.data.oncekiDonemTarihi);
                            setCariDonemBilgi(response.data.data);
                            return response.data.data.oncekiDonemTesvikBilgiInfoList;
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const kaydet = () => {

        let data = {
            domainId: props.data.domainId,
            donemId: cariDonemBilgi.cariDonemId,
            calisanSayi6111: cariDonemBilgi.cariDonemCalisanSayi6111,
            calisanSayi7103: cariDonemBilgi.cariDonemCalisanSayi7103
        }
        const request = new Request("/cariDonemTesvikRapor/saveCariDonemTesvikBilgi", "POST", data);
        return request.run()
            .then(response => {
                if (response.data && response.data.success) {
                    props.hide();
                }
            });
    }


    function on6111ValueChanged(args) {
        setCariDonemBilgi(Object.assign({}, cariDonemBilgi, { cariDonemCalisanSayi6111: args.value }));
    }
    function on7103ValueChanged(args) {
        setCariDonemBilgi(Object.assign({}, cariDonemBilgi, { cariDonemCalisanSayi7103: args.value }));
    }
    function onTahminiTaseronValueChanged(args) {
        if (args != null && args.value != null && args.value != cariDonemBilgi.cariDonemTahminiTaseronPersonelSayi) {
            let valueYeni6111Sayi = cariDonemBilgi.cariDonemCalisanSayi7103 + args.value; 
            setCariDonemBilgi(Object.assign({}, cariDonemBilgi, { cariDonemCalisanSayi6111: valueYeni6111Sayi, cariDonemTahminiTaseronPersonelSayi: args.value }));
            //setCariDonemBilgi(Object.assign({}, cariDonemBilgi, { cariDonemTahminiTaseronPersonelSayi: args.value }));
        }
    }
    function getDonemText(args) {
        if (args != null) {
            return args.getFullYear() + "/" + (args.getMonth() + 1).toString().padStart(2, '0');
        }
        return "";
    }

 
    return (
        <div >
            <div>
                <React.Fragment>
                    <div className="dx-fieldset">
                        <div className="dx-fieldset-header">Cari Dönem {getDonemText(cariDonemBilgi.cariDonemTarih)}</div>

                        <div className="dx-field">
                            <div className="dx-field-label">Personel İşe Giriş Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={true} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.cariDonemPersonelGirisSayi} 
                                    disabled={true}/>
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Personel Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={true}
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.cariDonemPersonelSayi} 
                                    disabled={true}/>
                            </div>
                        </div>

                        <div className="dx-field">
                            <div className="dx-field-label">Tahmini Taşeron Pesonel Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox readOnly={false} 
                                    hoverStateEnabled={false}
                                    value={cariDonemBilgi.cariDonemTahminiTaseronPersonelSayi}
                                    onValueChanged={onTahminiTaseronValueChanged} />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Giriş Çıkış Fark</div>
                            <div className="dx-field-value">
                                <NumberBox readOnly={true} 
                                    hoverStateEnabled={false}
                                    value={cariDonemBilgi.personelGirisCikisFark} />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">6111 Çalışan Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox  
                                    readOnly={false} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.cariDonemCalisanSayi6111} 
                                    onValueChanged={on6111ValueChanged} />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">7103 Çalışan Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={false} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.cariDonemCalisanSayi7103} 
                                    onValueChanged={on7103ValueChanged} />
                            </div>
                        </div>

                        <div className="dx-field">
                            <div className="dx-field-label">Personel Sayı (Xml ile alınan)</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={true} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.cariDonemDataPersonelSayi}  
                                    disabled={true} />
                            </div>
                        </div>
                    </div>


                    <div className="dx-fieldset">
                        <div className="dx-fieldset-header">Önceki Dönem {getDonemText(cariDonemBilgi.oncekiDonemTarihi)}</div>
                        <div className="dx-field">
                            <div className="dx-field-label">Personel Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={true} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.oncekiDonemBildirgePersonelSayi} 
                                    disabled={true}/>
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Personel İşten Çıkış Sayı</div>
                            <div className="dx-field-value">
                                <NumberBox 
                                    readOnly={true} 
                                    hoverStateEnabled={false} 
                                    value={cariDonemBilgi.oncekiDonemPersonelCikisSayi}
                                    disabled={true} />
                            </div>
                        </div>
                    </div>

                    <Button 
                        icon="plus" 
                        width={450} 
                        text="Kaydet" 
                        type={'success'} 
                        style={{ fontSize: "15px" }} 
                        visible={formYetki.cariDonemBilgiKaydetme}
                        onClick={kaydet}>

                        </Button>
                </React.Fragment>
            </div>
            <div>
                <DataGrid
                    width="100%"
                    height="200px"
                    dataSource={store}
                    key="id"
                    keyExpr="id"
                    showBorders={true}
                    focusedRowEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode={"widget"}
                    columnAutoWidth={false}
                    selection={{ mode: 'single', deferred: true }}
                >

                    <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                    <Column dataField="tarih" width={70} caption={'Dönem'} dataType="date" format="yyyy/MM" visible={true} />
                    <Column dataField={'calisanSayi6111'} minWidth={90} width={90} caption={'6111 Sayı'} dataType="string" mappingType="String" visible={true} />
                    <Column dataField={'calisanSayi7103'} minWidth={90} width={90} caption={'7103 Sayı'} dataType="string" mappingType="String" visible={true} />
                </DataGrid>
            </div>

        </div>
    )
}

export default CariDonemBilgi;
